import links from '../../../routes/links'
import { NavGroupType } from '../../../types/navs.types'

import InboxIcon from '@mui/icons-material/Inbox'
import GroupsIcon from '@mui/icons-material/Groups'
import Groups3Icon from '@mui/icons-material/Groups3'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'

const leaveRequests: NavGroupType = {
  label: 'Leave Requests',
  items: [
    { icon: <InboxIcon />, label: 'Unresponded', link: links.admin.leaveRequestUnresponded() },
    { icon: <GroupsIcon />, label: 'INDO', link: links.admin.leaveRequestIndoTeam() },
    { icon: <Groups3Icon />, label: 'JAPAN', link: links.admin.leaveRequestJapanTeam() },
  ],
}

const medicalReimbursement: NavGroupType = {
  label: 'Medical Reimbursement',
  items: [
    { icon: <InboxIcon />, label: 'Unresponded', link: links.admin.medicalReimbursementUnresponded() },
    { icon: <MedicalServicesIcon />, label: 'Responded', link: links.admin.medicalReimbursementResponded() },
  ],
}

const navs = [leaveRequests, medicalReimbursement]

export default navs
